import * as React from 'react';
import {Spinner, View} from '@packages/systems/spring';

interface StatusRowSpinnerIconProps {
  'aria-label'?: string;
}

/**
 * Spinner aligned to the 16px status icon column used by check / X rows.
 * Centers a 14px spinner in the same footprint as Spring status icons.
 */
export const StatusRowSpinnerIcon = ({
  'aria-label': ariaLabel = 'Loading',
}: StatusRowSpinnerIconProps) => (
  <View
    flexShrink={0}
    width={16}
    height={16}
    display="flex"
    alignItems="center"
    justifyContent="center"
  >
    <Spinner size={14} aria-label={ariaLabel} />
  </View>
);

StatusRowSpinnerIcon.displayName = 'StatusRowSpinnerIcon';
